import type { LucideIcon, LucideProps } from "lucide-react";

export interface IconProps extends LucideProps {
  icon: LucideIcon;
}

export function Icon({ icon: I, size = 24, strokeWidth = 2.25, ...rest }: IconProps) {
  return <I size={size} strokeWidth={strokeWidth} {...rest} />;
}
